import 'css-chunksrc/client/scenes/preferences/styles.scss';export default {
  "preferences": "_preferences_1biqc_1",
  "main": "_main_1biqc_8",
  "title": "_title_1biqc_12",
  "section": "_section_1biqc_17",
  "form": "_form_1biqc_21",
  "security": "_security_1biqc_33",
  "notifications": "_notifications_1biqc_42",
  "activityReport": "_activityReport_1biqc_51",
  "mfa": "_mfa_1biqc_60",
  "changePassword": "_changePassword_1biqc_69",
  "checkbox": "_checkbox_1biqc_73",
  "formWrapper": "_formWrapper_1biqc_78",
  "label": "_label_1biqc_82",
  "loader": "_loader_1biqc_89",
  "loaderMain": "_loaderMain_1biqc_104"
};